<template>
  <div class="daily-countries-figures">
    <v-row v-if="orders.length" height="150px">
      <v-col cols="12" sm="6" md="4">
        <v-card>
          <v-row>
            <v-col>
              <v-card :elevation="0">
                <v-card-title class="d-flex justify-center caption">
                  <span class="text-h6">Total</span>
                </v-card-title>
                <v-card-text class="title d-flex justify-center">
                  <span>{{orders.length}}</span>
                  <v-icon :color="totalDiff.color" small class="mx-2">{{totalDiff.icon}}</v-icon>
                  <span
                    :class="totalDiff.color + '--text text-caption d-flex align-center'"
                  >({{totalDiff.label}})</span>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col>
              <v-card :elevation="0">
                <v-card-title class="d-flex justify-center caption">
                  <span class="text-h6">Avg. (€)</span>
                </v-card-title>
                <v-card-text class="title d-flex justify-center">
                  <span>{{averagePrice}}</span>
                  <v-icon
                    :color="averagePriceDiff.color"
                    small
                    class="mx-2"
                  >{{averagePriceDiff.icon}}</v-icon>
                  <span
                    :class="averagePriceDiff.color + '--text text-caption d-flex align-center'"
                  >({{averagePriceDiff.label}})</span>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="8">
        <v-card>
          <v-row>
            <v-col v-for="[key, value] of Object.entries(countryDiff)" :key="key">
              <v-card :elevation="0">
                <v-card-title class="d-flex justify-center caption">
                  <span v-html="getIconByCountry(key)" class="text-h6"></span>
                </v-card-title>
                <v-card-text class="title d-flex justify-center">
                  <span>{{value.current}}</span>
                  <v-icon :color="value.diff.color" small class="mx-2">{{value.diff.icon}}</v-icon>
                  <span
                    :class="value.diff.color + '--text text-caption d-flex align-center'"
                  >({{value.diff.label}})</span>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  props: {
    orders: { type: Array },
    lastWeekOrders: { type: Array },
  },
  computed: {
    countryDiff() {
      let res = {};
      for (let [key, value] of Object.entries(this.ordersByCountry)) {
        if (!(key in res)) {
          res[key] = {};
        }
        res[key]["current"] = value.length;
        res[key]["lastWeek"] = 0;
      }
      for (let [key, value] of Object.entries(this.lastWeekOrdersByCountry)) {
        if (!(key in res)) {
          res[key] = {};
        }
        res[key]["lastWeek"] = value.length;
        if (!("current" in res[key])) {
          res[key]["current"] = 0;
        }
      }
      for (let value of Object.values(res)) {
        let diff = null;
        if (value.lastWeek) {
          diff = Math.round(
            ((value.current - value.lastWeek) / value.lastWeek) * 100
          );
        }
        value["diff"] = this.getDiffStyle(diff);
      }
      return res;
    },
    ordersByCountry() {
      return _.chain(this.orders).groupBy("country_code").value();
    },
    lastWeekOrdersByCountry() {
      return _.chain(this.lastWeekOrders).groupBy("country_code").value();
    },
    totalDiff() {
      let diff = null;
      if (this.lastWeekOrders.length) {
        diff = Math.round(
          ((this.orders.length - this.lastWeekOrders.length) /
            this.lastWeekOrders.length) *
            100
        );
      }
      return this.getDiffStyle(diff);
    },
    averagePrice() {
      return this.getAveragePrice(this.orders);
    },
    lastWeekAveragePrice() {
      return this.getAveragePrice(this.lastWeekOrders);
    },
    averagePriceDiff() {
      let diff = null;
      if (this.lastWeekAveragePrice) {
        diff = Math.round(
          ((this.averagePrice - this.lastWeekAveragePrice) /
            this.lastWeekAveragePrice) *
            100
        );
      }
      return this.getDiffStyle(diff);
    },
  },
  methods: {
    getIconByCountry(country) {
      let countriesIcons = {
        SP: "&#x1F1EA;&#x1F1F8;",
        FR: "&#x1F1EB;&#x1F1F7;",
        UK: "&#x1f1ec;&#x1f1e7;",
        UAE: "&#127462;&#127466;",
      };
      return country in countriesIcons ? countriesIcons[country] : country;
    },
    getAveragePrice(orders) {
      if (orders.length) {
        return (
          Math.round(
            (_.chain(orders).sumBy("price_in_euros").value() / orders.length) *
              100
          ) / 100
        );
      }
      return 0;
    },
    getDiffStyle(diff) {
      let label = "-";
      let icon = "mdi-dots-horizontal";
      let color = "grey";
      if (diff < 0) {
        icon = "mdi-arrow-down-bold-circle";
        color = "error";
        label = diff + "%";
      } else if (diff > 0) {
        icon = "mdi-arrow-up-bold-circle";
        color = "success";
        label = "+" + diff + "%";
      } else {
        icon = "mdi-arrow-right-bold-circle";
        color = "warning";
        label = diff + "%";
      }
      return {
        label: label,
        icon: icon,
        color: color,
      };
    },
  },
};
</script>
